import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0e9e5470&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=0e9e5470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9e5470",
  null
  
)

export default component.exports